module.exports = __webpack_public_path__ + "static/media/pie-chart-new.48826914.png";